module.exports = __webpack_public_path__ + "static/media/forcesActingOnParticle3.e858b3a4.svg";